// public
export { EntrarComponent } from './entrar/entrar.component';
export { DocumentacaoComponent } from './documentacao/documentacao.component';
export { HomeComponent } from './home/home.component';
export { AgendamentoComponent } from './agendamento/agendamento.component';
export { AcessoInternoComponent } from './acesso-interno/acesso-interno.component';

// private
export * from './private/recadastramento/index';
export { AcompanhamentoComponent } from './private/acompanhamento/acompanhamento.component';
export { ContestacaoComponent } from './private/contestacao/contestacao.component';
export { ModalAvaliarAtendimentoComponent } from './private/acompanhamento/modal-avaliar-atendimento/modal-avaliar-atendimento.component'
